import { forwardRef } from 'react';

import { IconProps } from '../';

export const TimelineSquareIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <g filter="url(#filter0_d_4003_40693)">
        <rect x="5" y="5" width="10" height="10" rx="1" fill="#3EC5D6" />
        <rect x="4" y="4" width="12" height="12" rx="2" fill="none" stroke="white" strokeWidth="2" />
      </g>
      <defs>
        <filter id="filter0_d_4003_40693" x="1" y="2" width="18" height="18" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4003_40693" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4003_40693" result="shape" />
        </filter>
      </defs>
    </svg>
  );
});

export default TimelineSquareIcon;
